import React from 'react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { MenuItem, Select, SelectChangeEvent, Stack, Typography } from '@mui/material'

import { baseColor } from '#/shared/lib/constants/colors'

import styles from './select.module.scss'

interface ISelect {
	value: any
	onChange: (e: SelectChangeEvent<string>) => void
	list?: any
	valueKey?: string  // для определения поля value (например, 'slug')
	labelKey?: string  // для определения поля label (например, 'title')
	children?: React.ReactNode
	[x: string]: any
}

export const SelectUI: React.FC<ISelect> = ({ 
	value, 
	onChange, 
	list, 
	title, 
	valueKey, 
	labelKey, 
	children, 
	...args 
}) => {

	return (
		<Stack spacing={0.5}>
			{title && <Typography className='title-main-gray'>{title}</Typography>}
			<Select
				IconComponent={KeyboardArrowDownIcon}
				value={value}
				onChange={onChange}
				inputProps={{
					MenuProps: {
						MenuListProps: {
							backgroundColor: 'transparent',
							sx: {
								color: '#A6A5A5',
								backgroundColor: '#151518',
							},
						},
					},
				}}
				className={styles.selectTransparent}
				sx={{
					boxShadow: 'none',
					borderRadius: '13px',
					backgroundColor: '#4B4B4B',
					border: '2px solid #40404E;',
					color: '#A6A5A5',
					'.MuiSelect-icon': {
						color: '#A6A5A5',
					},
					'&& fieldset': {
						border: '0px solid transparent',
					},
					'&.Mui-focused': {
						border: '2px solid #40404E;',
						borderColor: baseColor,
						'& .MuiOutlinedInput-notchedOutline': {
							border: 'none',
						},
					},
					'&:hover': {
						'&& fieldset': {
							border: '0px solid transparent',
						},
					},
				}}
				fullWidth
				{...args}
			>
				{list?.map((item: any) => {
					// Если переданы ключи для объекта, используем их
					const itemValue = valueKey ? item[valueKey] : item
					const itemLabel = labelKey ? item[labelKey] : item
					const itemKey = valueKey ? item[valueKey] : item
					
					return (
						<MenuItem key={itemKey} value={itemValue}>
							<Typography sx={{ fontSize: '18px' }}>{itemLabel}</Typography>
						</MenuItem>
					)
				})}
				{children}
			</Select>
		</Stack>
	)
}